import React from 'react';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';

import { Home } from './pages/Home';
import { About } from './pages/About';
import { Portfolio } from './pages/Portfolio';
import { AllProjects } from './pages/AllProjects';
import { Services } from './pages/Services';
import { Contact } from './pages/Contact';
import { Privacy } from './pages/Privacy';
import { Terms } from './pages/Terms';
import { Cookies } from './pages/Cookies';
import { Disclaimer } from './pages/Disclaimer';
import { Sitemap } from './pages/Sitemap';
import { Tools } from './pages/Tools';
import { Consultation } from './pages/Consultation';
import { Store } from './pages/Store';
import { ErrorPage } from './pages/ErrorPage';
import LocalRouteHome from './pages/portfolio/local-route/Home';
import LocalRoutePrivacy from './pages/portfolio/local-route/Privacy';
import LocalRouteRoot from './pages/portfolio/local-route/LocalRouteRoot';
import PhoneticHome from './pages/portfolio/phonetic/Home';
import PhoneticPrivacy from './pages/portfolio/phonetic/Privacy';
import PhoneticRoot from './pages/portfolio/phonetic/PhoneticRoot';

import { Layout } from './components/Layout';

const router = createBrowserRouter([
  {
    path: '/',
    element: <Layout><Home /></Layout>,
    errorElement: <ErrorPage />,
  },
  {
    path: '/about',
    element: <Layout><About /></Layout>,
    errorElement: <ErrorPage />,
  },
  {
    path: '/free-tools',
    element: <Layout><Portfolio /></Layout>,
    errorElement: <ErrorPage />,
  },
  {
    path: '/portfolio',
    element: <Layout><AllProjects /></Layout>,
    errorElement: <ErrorPage />,
  },
  {
    path: '/services',
    element: <Layout><Services /></Layout>,
  },
  {
    path: '/tools',
    element: <Layout><Tools /></Layout>,
  },
  {
    path: '/consultation',
    element: <Layout><Consultation /></Layout>,
  },
  {
    path: '/store',
    element: <Layout><Store /></Layout>,
  },
  {
    path: '/contact',
    element: <Layout><Contact /></Layout>,
  },
  {
    path: '/privacy',
    element: <Layout><Privacy /></Layout>,
  },
  {
    path: '/terms',
    element: <Layout><Terms /></Layout>,
  },
  {
    path: '/cookies',
    element: <Layout><Cookies /></Layout>,
  },
  {
    path: '/disclaimer',
    element: <Layout><Disclaimer /></Layout>,
    errorElement: <ErrorPage />,
  },
  {
    path: '/sitemap',
    element: <Layout><Sitemap /></Layout>,
    errorElement: <ErrorPage />,
  },
  {
    path: '/portfolio/local-route',
    element: <LocalRouteRoot />,
    errorElement: <ErrorPage />,
    children: [
      {
        index: true,
        element: <LocalRouteHome />,
      },
      {
        path: 'privacy',
        element: <LocalRoutePrivacy />,
      },
    ],
  },
  {
    path: '/portfolio/phonetic',
    element: <PhoneticRoot />,
    errorElement: <ErrorPage />,
    children: [
      {
        index: true,
        element: <PhoneticHome />,
      },
      {
        path: 'privacy',
        element: <PhoneticPrivacy />,
      },
    ],
  }
], {
  basename: '/'
});

const App: React.FC = () => {
  return <RouterProvider router={router} />;
};

export default App;